module.exports = __webpack_public_path__ + "img/case-bj3.84a2ad26.png";